import { ArticleShareProps } from '@bridebook/web/app-basic/components/articles/share/article-share.types';
import { SocialSharing } from '@bridebook/web/app-basic/components/social-sharing';
import { useRouter } from 'next/router';
import { memo } from 'react';
import { extractArticleTags } from '@bridebook/toolbox/src';
import { Box } from '@bridebook/ui';
import { IArticle, IArticleShareInfoType } from '@bridebook/web/app-shared/lib/articles/types';
import { extractArticleCategory } from '@bridebook/web/app-shared/lib/articles/utils';
import { getArticlePath } from '@bridebook/web/lib/articles/constants/articleCategories';
import componentStyles from './article-share.style';

interface IProps extends ArticleShareProps {
  article: IArticle;
}

const ArticleShareComponent = ({ article, pinImage }: IProps) => {
  const styles = componentStyles();

  const { query, locale } = useRouter();

  if (!article || !query?.articleId) return null;

  const { title } = article;

  const tags: Array<string> = extractArticleTags(article);
  const category = extractArticleCategory(article);
  const type = 'article';
  const shareInfo: IArticleShareInfoType = {
    categories: category,
    type,
    category,
    tags,
    title,
  };
  const itemLink: string = `https://bridebook.com/${locale}${getArticlePath(article)}`;

  return (
    <Box style={styles.wrapper}>
      <SocialSharing pinImage={pinImage} itemLink={itemLink} description={title} info={shareInfo} />
    </Box>
  );
};

export const ArticleShare = memo(ArticleShareComponent);
